import React, { useEffect, useState, useRef } from 'react';
import { connect, history, useLocation } from 'umi';

import { Form } from 'antd';
import classNames from 'classnames';

import Header from '@/components/Header';
import BasicBaseSpin from '@/components/BasicBaseSpin';
import { Clickable } from '@/components';
import useGCPI18n from '@/hooks/useGCPI18n';
import { formatDateNew } from '@/utils/utils';
import { sanitizeParam } from '@/utils/sanitize';
import { C2C_FONT_FAMILY } from '@/utils/constants';
import { RewardClaimDialogs } from '../components/RewardClaimDialog';
import useRewardClaimFlow from '../hooks/useRewardClaimFlow';
import useRewardClaimOptions from '../hooks/useRewardClaimOptions';
import useRewardListScroll from '../hooks/useRewardListScroll';

import styles from './index.less';

const PostPaidC2CDetail = props => {
  const GCPI18n = useGCPI18n();
  const [form] = Form.useForm();
  const { pageRenderDetail, loading, dispatch, isManual, applyTo, activityDetail } = props;

  // const [qryType, setQryType] = useState('');
  const [pageNum, setPageNum] = useState(1);
  const [listTotal, setListTotal] = useState(0);
  const [rewardList, setRewardList] = useState([]);

  const containerRef = useRef(null);
  const isSpecificTime = true;

  // const { promotionId } = JSON.parse(localStorage.getItem('promotionId')) || {};
  const { query } = useLocation();
  const rawQuery = history.location.query || {};
  const custName = props.selectedCustName || '';
  const promReferInstId = sanitizeParam(rawQuery.promReferInstId);
  const { mainColor } = pageRenderDetail || {};
  const { chooseSubNumMethod, subNumType, promotionId } = activityDetail || {};
  const pageFontFamily = C2C_FONT_FAMILY?.[pageRenderDetail?.fontFamily];
  const { phoneRegex, serviceNumberList } = useRewardClaimOptions({
    dispatch,
    chooseSubNumMethod,
    subNumType,
  });
  const rewardListRef = useRef(rewardList);
  const listTotalRef = useRef(listTotal);

  // 更新 ref 的值
  useEffect(() => {
    rewardListRef.current = rewardList;
    listTotalRef.current = listTotal;
  }, [rewardList, listTotal]);

  const handleDetailQry = async value => {
    const res = await dispatch({
      type: 'postPaidC2c/qryInviteeDetailDXP',
      payload: {
        promReferInstId,
        pageIndex: value?.pageNum || pageNum,
        pageSize: '100',
      },
    });
    const { pageInfo = {}, data } = res || {};
    const { actionList: list } = data || {};
    if (!listTotal || listTotal !== pageInfo?.total) {
      setListTotal(pageInfo?.total || 0);
    }
    if (pageInfo?.currentPage > 1) {
      setRewardList([...(rewardList || []), ...(list || [])]);
    } else {
      setRewardList(list);
    }
  };

  const handlePageNumChange = () => {
    setPageNum(pageNum + 1);
    handleDetailQry({
      pageNum: pageNum + 1,
    });
  };

  const claimFlow = useRewardClaimFlow({
    form,
    dispatch,
    chooseSubNumMethod,
    pageRenderDetail,
    refreshAfterClaim: () => {
      setPageNum(1);
      handleDetailQry({
        pageNum: 1,
      });
    },
  });

  useRewardListScroll({
    containerRef,
    listRef: rewardListRef,
    totalRef: listTotalRef,
    onReachBottom: handlePageNumChange,
  });

  useEffect(() => {
    // 查询列表
    if (promotionId) handleDetailQry();
  }, [promotionId, query]);

  return (
    <div className={styles.pageWrap} style={{ fontFamily: pageFontFamily }}>
      <BasicBaseSpin spinning={loading} size="large">
        <Header
          title={GCPI18n('lb_post_paid_referral_detail')}
          titleColor="#3E3E3E"
          titleFontFamily={pageFontFamily}
          goBack={() => history.goBack()}
          hideGoHome
        />
        <div className={styles.custNameBox}>{custName}</div>
        <div className={styles.contain}>
          <div className={styles.listBox} ref={containerRef}>
            {(rewardList || []).map(item => {
              const {
                invitationStatus,
                partnerSn,
                eventDate,
                referrerRewardList,
                inviteeRewardList,
                eventTypeId,
                mainOfferName,
              } = item || {};
              return (
                <div className={styles.itemBox}>
                  <div className={styles.status}>{invitationStatus}</div>
                  {partnerSn && (
                    <div className={styles.partnerSn}>
                      <div className={styles.label}>
                        {GCPI18n('lb_post_paid_transaction_number')}
                      </div>
                      <div className={styles.value}>{partnerSn}</div>
                    </div>
                  )}
                  <div className={styles.eventDate}>
                    <div className={styles.label}>{GCPI18n('lb_post_paid_completion_date')}</div>
                    <div className={styles.value}>{formatDateNew(eventDate, isSpecificTime)}</div>
                  </div>
                  {(inviteeRewardList || []).map((inReward, index) => (
                    <div className={styles.inRewardBox}>
                      <div className={styles.label}>
                        {index === 0 && GCPI18n('lb_post_paid_invitee_reward')}
                      </div>
                      {inReward?.rewardName && (
                        <div className={styles.value}>{inReward?.rewardName}</div>
                      )}
                    </div>
                  ))}
                  {(referrerRewardList || []).map((reReward, index) => {
                    const { rewardName, state } = reReward || {};
                    const { claimRewardButtonText } = pageRenderDetail || {};
                    const showClaimOptions =
                      isManual === 'Y' ||
                      applyTo === 'All' ||
                      applyTo === 'S' ||
                      reReward.isManualClaim;

                    return (
                      <div
                        className={classNames(
                          styles.reRewardBox,
                          showClaimOptions && state === 'A' && styles.needMargin,
                        )}
                        key={index}
                      >
                        <div className={styles.label}>
                          {index === 0 && GCPI18n('lb_post_paid_my_reward')}
                        </div>
                        {rewardName && (
                          <div className={styles.showStatusBox}>
                            <div className={styles.value}>{rewardName}</div>
                            {showClaimOptions && (
                              <>
                                {state === 'A' && (
                                  <Clickable
                                    onClick={() => claimFlow.handleClaimReward(reReward)}
                                    className={styles.claimBtn}
                                    style={{ backgroundColor: mainColor }}
                                  >
                                    {claimRewardButtonText}
                                  </Clickable>
                                )}
                                {state === 'B' && (
                                  <div className={styles.claimedText}>
                                    {GCPI18n('lb_post_paid_claimed')}
                                  </div>
                                )}
                                {state === 'E' && (
                                  <div className={styles.expiredText}>
                                    {GCPI18n('lb_post_paid_expired')}
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                  {referrerRewardList?.[0]?.receiveDeadDate && (
                    <div className={styles.receiveDeadDate}>
                      <div className={styles.label}>{GCPI18n('lb_post_paid_claim_before')}</div>
                      <div className={styles.value}>
                        {formatDateNew(referrerRewardList?.[0]?.receiveDeadDate, isSpecificTime)}
                      </div>
                    </div>
                  )}
                  {eventTypeId === 44 && mainOfferName && (
                    <div className={styles.mainOfferName}>
                      <div className={styles.label}>{GCPI18n('lb_post_paid_applied_plan')}</div>
                      <div className={styles.value}>{mainOfferName}</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </BasicBaseSpin>
      <RewardClaimDialogs
        claimFlow={claimFlow}
        styles={styles}
        form={form}
        pageFontFamily={pageFontFamily}
        pageRenderDetail={pageRenderDetail}
        chooseSubNumMethod={chooseSubNumMethod}
        serviceNumberList={serviceNumberList}
        phoneRegex={phoneRegex}
        mainColor={mainColor}
        GCPI18n={GCPI18n}
      />
    </div>
  );
};

export default connect(({ index, postPaidC2c, loading }) => ({
  pageRenderDetail: index.pageRenderDetail,
  activityDetail: index.activityDetail,
  isManual: index.isManual,
  applyTo: index.applyTo,
  selectedCustName: postPaidC2c.selectedCustName,
  loading:
    loading.effects['postPaidC2c/qryUserRewardListDXP'] ||
    loading.effects['postPaidC2c/qryInviteeDetailDXP'] ||
    loading.effects['myAwards/claimRewardDXP'] ||
    false,
}))(PostPaidC2CDetail);
